import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApplicationKey } from '../models';
import { map } from 'rxjs/operators';
import { ApiBaseService } from '../crud.service';

@Injectable()
export class ApplicationKeyService extends ApiBaseService {
    constructor(protected httpClient: HttpClient) {
        super(httpClient, '/application/key');
    }

    generate(data: ApplicationKey): Observable<ApplicationKey> {
        return this.httpClient
            .post(`${this.basePath}/generate`, { data })
            .pipe(map((res: any) => res.data));
    }

    enable(data: ApplicationKey): Observable<ApplicationKey> {
        return this.httpClient.post(`${this.basePath}/enable`, { data });
    }

    disable(data: ApplicationKey): Observable<ApplicationKey> {
        return this.httpClient.post(`${this.basePath}/disable`, { data });
    }

    getStatus(applicationKey: string): Observable<ApplicationKey> {
        return this.httpClient
            .get(`${this.basePath}/${applicationKey}`)
            .pipe(map((res: any) => res.data));
    }
}
